<template>
<div>
  <Main />
</div>
</template>

<script>
import Main from "./maplocation/Main";

export default {
  name: "Menu",
  components: {
    Main,
  },
}
</script>

<style scoped>

</style>